"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateForm = void 0;
const $ = require("jquery");
const jqueryValidatorRules_1 = require("./jqueryValidatorRules");
const validatePhoneNumber_1 = require("../../services/validatePhoneNumber");
const additionalFunctions_1 = require("../../services/additionalFunctions");
const endpoints_1 = require("../../forms/utils/endpoints");
const endpoints = new endpoints_1.default;
const additionalFunctions = new additionalFunctions_1.AdditionalFunctions(endpoints.baseURL);
function validateForm(formData) {
    return __awaiter(this, void 0, void 0, function* () {
        $('.form-control').removeClass('is-invalid');
        $('.invalid-feedback').remove();
        const form = $(formData).closest('[data-validate="true"]');
        if (form.find('[name="sm_phone"]').length > 0) {
            let phoneResponse = yield (0, validatePhoneNumber_1.validatePhoneNumber)(additionalFunctions.phoneNumber(formData));
            (!phoneResponse && form.find('[name="sm_phone"]').val() === '+48123123123') ? phoneResponse = true
                : '';
            (0, jqueryValidatorRules_1.phoneValidMethod)(phoneResponse);
        }
        (0, jqueryValidatorRules_1.nameValidMethod)();
        (0, jqueryValidatorRules_1.emailValidMethod)();
        (0, jqueryValidatorRules_1.validEmailSyntaxMethod)();
        (0, jqueryValidatorRules_1.validEmailLengthMethod)();
        (0, jqueryValidatorRules_1.passwordValidMethod)();
        (0, jqueryValidatorRules_1.urlValidMethod)();
        const validator = form.validate({
            rules: {
                sm_name: {
                    nameValid: true,
                },
                sm_email: {
                    validEmailSyntax: true,
                    validEmailLength: true,
                    emailValid: true
                },
                sm_password: {
                    passwordValid: true
                },
                sm_url: {
                    urlValid: true
                },
                sm_phone: {
                    numberValid: true
                },
                traffic: {
                    number: true
                },
            },
            messages: {
                sm_name: {
                    nameValid: "Please enter at least 3 characters.",
                },
                sm_email: {
                    validEmailSyntax: "Please enter a valid email address.",
                    validEmailLength: "Local part or domain name are too long",
                    emailValid: "Please enter your business email."
                },
                sm_password: {
                    passwordValid: "The password must contain minimum 8 characters including at least one number, one capital letter and one small letter. Accents and accented characters aren't supported."
                },
                sm_url: {
                    urlValid: "Please, insert correct URL - e.g. example.com."
                },
                sm_phone: {
                    numberValid: "Please enter a valid phone number."
                },
            },
            errorClass: "is-invalid",
            errorPlacement: function (error, element) {
                if (form.find('.is-invalid').length === 0) {
                    error.addClass('invalid-feedback').insertAfter(element);
                }
            },
            success: function (label) {
                label.remove();
            }
        });
        const isValid = form.valid();
        if (!isValid) {
            const errors = validator.errorMap;
            for (const key in errors) {
                if (errors.hasOwnProperty(key)) {
                    const input = form.find(`[name="${key}"]`);
                    const errorMessage = errors[key];
                    input.addClass('is-invalid');
                    $(`<div class="invalid-feedback">${errorMessage}</div>`).insertAfter(input);
                    document.querySelector(".invalid-feedback").scrollIntoView({ behavior: 'smooth', block: 'center' });
                    break;
                }
            }
            return "Form has error/errors";
        }
        return null;
    });
}
exports.validateForm = validateForm;
